export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_DETAIL_PRODUCT = "GET_DETAIL_PRODUCT";
export const GET_PRODUCTS_CLIENT = "GET_PRODUCTS_CLIENT";
export const GET_STATE_LOADING = "GET_STATE_LOADING"; 
export const GET_PRODUCT_BY_MODE = "GET_PRODUCT_BY_MODE";
export const GET_LIST_COUNTRY = "GET_LIST_COUNTRY";